import { Storage } from '../../services';

/**
 * TODO: Consider moving this class entirely (or almost entirely)
 * to `../../services`, which is essentially what this encodes: service
 * level knowledge and logic.
 */

/**
 * Notice!
 * 
 * This deviates from the way local-store works.
 * 
 * @param {*} name 
 */

export const VALID_ACCESS_LEVELS = ['public', 'protected', 'private'];

export const validateLevel = level => {
	if (!VALID_ACCESS_LEVELS.includes(level)) {
		throw new Error(`Invalid level provided to RemoteStore. Valid levels are [${VALID_ACCESS_LEVELS.join(', ')}].`);
	}
};

const RemoteStore = function(name, level = 'private') {

	validateLevel(level);

	this.name = name;

	this.save = async function(o) {
		await Storage.put(`${this.name}.json`, JSON.stringify(o), {
			level,
			contentType: "text/plain"
		});
		return o;
	};

	this.get = async function() {
		try {
			const result = await Storage.get(`${this.name}.json`, {
				level,
				download: true,
				cacheControl: 'no-cache'
			});
			return JSON.parse(await result.Body.text());
		} catch (error) {
			if (error.message.includes("NoSuchKey")) {
				return [];
			}
		}
	};

	this.delete = async function() {
		await Storage.remove(`${this.name}.json`, { level });
	};

};

RemoteStore.list = async (prefix = '', level = 'private', limit = 'ALL') => {
	validateLevel(level);

	const listing = await Storage.list(prefix, { level, maxKeys: limit });
	return listing
		.filter(({key}) => key.endsWith('.json'))
		.map(({key}) => new RemoteStore(
			key.replace(/\.json$/, ''),
			level
		))
	;
};

export default RemoteStore;
